import GridContainer from '@rsa-digital/evo-shared-components/components/GridContainer';
import React, { PropsWithChildren, useEffect } from 'react';
import AlertBanners from 'components/AlertBanners';
import Analytics from 'components/Analytics';
import { reloadOneTrust } from 'components/Analytics/onetrust';
import Breadcrumbs from 'components/Breadcrumbs';
import { BreadcrumbsData } from 'components/Breadcrumbs/types';
import FontTracking from 'components/FontTracking';
import { CustomisableFooter } from 'components/Footer';
import GlobalNotification from 'components/GlobalNotification';
import useGlobalNotificationData from 'components/GlobalNotification/useGlobalNotificationData';
import PageMetadata, { MetaTags } from 'components/PageMetadata';
import Header from '../Header';
import RefreshButton from '../RefreshButton';

/* istanbul ignore next */
const activeEnv = process.env.GATSBY_ACTIVE_ENV || process.env.NODE_ENV || 'development';
const showRefreshButton =
  process.env.GATSBY_HIDE_REFRESH_BUTTON !== 'true' &&
  (activeEnv === 'development' || activeEnv === 'preview');
const disableAnalytics = process.env.GATSBY_DISABLE_ANALYTICS === 'true';

type LayoutProps = {
  pageMetadata: MetaTags;
  breadcrumbs?: BreadcrumbsData;
  locale: string;
  url: string;
  disableGlobalNotification?: boolean;
};

const Layout: React.FC<PropsWithChildren<LayoutProps>> = ({
  pageMetadata,
  breadcrumbs,
  locale,
  url,
  disableGlobalNotification,
  children,
}) => {
  useEffect(() => {
    if (!disableAnalytics) {
      reloadOneTrust();
    }
  }, []);
  const showBreadcrumbs = !!(
    breadcrumbs?.current_page_name || breadcrumbs?.parent_links?.length
  );
  const globalNotificationData = useGlobalNotificationData(locale);

  return (
    <>
      {!disableAnalytics && <Analytics />}
      <FontTracking />
      <PageMetadata meta={pageMetadata} />
      <Header locale={locale} />
      {!disableGlobalNotification && globalNotificationData && (
        <GlobalNotification {...globalNotificationData} />
      )}
      <AlertBanners pageUrl={url || ''} />
      <GridContainer as="main">
        {showRefreshButton && /* istanbul ignore next */ <RefreshButton />}
        {children}
        {showBreadcrumbs && <Breadcrumbs breadcrumbs={breadcrumbs} locale={locale} />}
      </GridContainer>
      <GridContainer>
        <CustomisableFooter locale={locale} />
      </GridContainer>
    </>
  );
};

export default Layout;
